import { makeStyles } from '@material-ui/core/styles'

export const singleInvoiceStyles = makeStyles((theme) => ({
  invoiceGeneralDataWrapper: {
    width: '100%',
    padding: theme.spacing(2.5, 2, 3),
    backgroundColor: theme.palette.primary.lighter,
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    color: theme.palette.common.white,
    '& label': {
      color: theme.palette.common.white,
      fontWeight: theme.typography.fontWeightRegular
    }
  },
  invoiceTitleActionWrapper: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
    '& .MuiTypography-root': {
      fontWeight: theme.typography.fontWeightSemiBold,
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        marginRight: theme.spacing(0.5)
      }
    }
  },
  buttonAction: {
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightSemiBold,
    color: theme.palette.common.white,
    transition: 'all 0.5s ease-in-out',

    '&:not(.inner)': {
      padding: theme.spacing(0)
    },
    '& + $buttonAction': {
      paddingLeft: theme.spacing(2)
    },
    '&.inner': {
      color: theme.palette.text.primary,
      backgroundColor: 'transparent',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: theme.typography.fontWeightRegular,
      textAlign: 'left',
      padding: theme.spacing(1, 1.5),
      width: '100%',
      justifyContent: 'flex-start'
    },
    '& i, & svg': {
      marginRight: theme.spacing(0.5),
      fontSize: theme.typography.pxToRem(20)
    },
    '& strong': {
      marginLeft: theme.spacing(0.5)
    },
    '&:hover': {
      color: theme.palette.secondary.main,
      backgroundColor: 'transparent'
    }
  },
  submissionLinkWrapper: {
    width: '100%',
    // marginTop: theme.spacing(1),
    fontSize: theme.typography.pxToRem(12),
    '& > p': {
      marginBottom: theme.spacing(0.75)
    }
  },
  submissionLink: {
    color: theme.palette.primary.dark,
    padding: theme.spacing(0),
    marginLeft: theme.spacing(0.5),
    transition: 'all 0.5s ease-in-out',
    '&:hover': {
      color: theme.palette.secondary.main,
      backgroundColor: 'transparent'
    }
  },
  invoiceStatusWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  invoiceStatusValueWrapper: {
    display: 'flex',
    alignItems: 'center',
    // minWidth: '40%',
    '& > svg': {
      marginLeft: theme.spacing(1.5),
      marginRight: theme.spacing(1.5)
    }
  },
  invoiceStatusContainer: {
    display: 'flex',
    alignItems: 'center',
    lineHeight: 1.7,
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightSemiBold,
    padding: theme.spacing(0.25, 2),
    '& svg': {
      marginRight: theme.spacing(0.25),
      fontSize: theme.typography.pxToRem(18)
    },
    '&.valid': {
      backgroundColor: theme.palette.success.main
    },
    '&.invalid': {
      backgroundColor: theme.palette.warning.dark
    },
    '&.cancelled': {
      backgroundColor: theme.palette.grey[400]
    },
    '&.rejected': {
      backgroundColor: theme.palette.error.main
    },
    '&.submitted': {
      backgroundColor: theme.palette.success.dark
    },
    '&.spStatus, &.pending': {
      backgroundColor: theme.palette.colors.logoColor
    },
    '&.mixed': {
      // background: theme.palette.warning.dark,
      // background: `-moz-linear-gradient(90deg, ${theme.palette.success.main} 0%, ${theme.palette.warning.dark} 100%)`,
      // background: `-webkit-linear-gradient(90deg, ${theme.palette.success.main} 0%, ${theme.palette.warning.dark} 100%)`,
      background: `linear-gradient(90deg, ${theme.palette.success.main} 0%, ${theme.palette.warning.dark} 100%)`,
      filter: `progid:DXImageTransform.Microsoft.gradient(startColorstr="${theme.palette.success.main}",endColorstr="${theme.palette.warning.dark}",GradientType=1)`
    }

  },
  invoiceStatusReason: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(3),
    '& label': {
      marginRight: theme.spacing(0.75)
    }
  },

  invoiceDatesWrapper: {
    display: 'flex',
    width: `calc(100% + ${theme.spacing(2)}px)`,
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    position: 'relative',
    paddingTop: theme.spacing(2),
    marginLeft: theme.spacing(-1),
    marginRight: theme.spacing(-1),
    '&:not(.submission)': {
      marginTop: theme.spacing(2),
      '&:before': {
        content: '""',
        position: 'absolute',
        top: theme.spacing(0),
        left: theme.spacing(-1),
        height: 1,
        width: `calc(100% + ${theme.spacing(2)}px)`,
        backgroundColor: theme.palette.primary.border
      }
    }
  },
  printableDataItem: {
    width: '25%',
    fontSize: theme.typography.pxToRem(12),
    marginBottom: theme.spacing(1.5),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    '& label': {
      fontSize: theme.typography.pxToRem(14),
      marginBottom: theme.spacing(0.75)
    },
    '& .uuid-wrapper span':{
      marginRight: theme.spacing(0.5)
    }
  },
  dateContainer: {
    '& .date': {
      display: 'flex',
      alignItems: 'center'
    },
    '& strong': {
      display: 'flex',
      alignItems: 'flex-end',
      marginRight: theme.spacing(1)

    },
    '& svg': {
      fontSize: theme.typography.pxToRem(18),
      marginRight: theme.spacing(0.125)
    },
    '& .utc': {
      marginTop: theme.spacing(0.5),
      fontWeight: theme.typography.fontWeightSemiBold,
      '& span': {
        marginLeft: theme.spacing(0.5)
      }
    }
  },
  invoiceValidations: {
    width: '100%',
    marginTop: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    '& .MuiAlert-icon svg': {
      fontSize: theme.typography.pxToRem(40)
    },
    '& .MuiAlertTitle-root': {
      fontWeight: theme.typography.fontWeightBold
    },
    '& li .MuiAlertTitle-root': {
      fontWeight: theme.typography.fontWeightSemiBold
    },
    '& ul': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2)
    }
  },
  invoiceDataGroup: {
    width: '100%',
    '& .MuiAccordionSummary-root': {
      backgroundColor: theme.palette.colors.body,
      '&.Mui-expanded': {
        minHeight: theme.spacing(6)
      }
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      marginTop: theme.spacing(1.5),
      marginBottom: theme.spacing(1.5)
    },
    '& .MuiAccordionSummary-expandIcon': {
      color: theme.palette.secondary.main
    },
    '& .info:not(.row)': {
      width: '25%'
    }
  },
  itemsCalculations: {
    backgroundColor: theme.palette.colors.table,
    padding: theme.spacing(1.5),
    '& .total': {
      color: theme.palette.common.black,
      fontSize: theme.typography.pxToRem(18),
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      '& .MuiInputLabel-root': {
        color: theme.palette.common.black,
        fontWeight: theme.typography.fontWeightSemiBold
      }
    },
    '& .tax': {
      paddingLeft: theme.spacing(1.5)
    },
    '& .info': {
      alignItems: 'center',
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(0),
      marginBottom: theme.spacing(0.75),
      '&:not(.row)': {
        width: '40%',
        [theme.breakpoints.down('md')]: {
          width: '100%'
        }
      },
      '& .MuiInputLabel-root': {
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
        minHeight: 'auto',
        color: theme.palette.text.secondary
      },
      '& .info-data': {
        flex: '1 1 auto',
        marginTop: theme.spacing(0),
        marginBottom: theme.spacing(0),
        textAlign: 'right',
      }
    }

  }
}))
